import React from "react";
// import { Dialog } from "@surgia/ui/components/dialog";
import closeIcon from "@surgia/ui/icons/popup/close.svg";

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  icon?: React.ReactNode;
  additionalStyles?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  icon,
  additionalStyles,
}) => {
  if (!open) return null;

  return (
    <div className={`relative p-8 ${additionalStyles}`}>
      {/* Close (X) icon */}
      <div className="mt-1 absolute top-2 left-3">{icon}</div>

      <img
        src={closeIcon}
        alt="Close"
        className="text-gray-400 hover:text-gray-600 absolute top-1 right-1"
        onClick={onClose}
      />

      <div className="flex items-start gap-6 mt-10">
        {/* Icon on the left */}
        {/* Content */}
        <div>
          <h2 className="text-xl font-bold mb-1">{title}</h2>
          <p className="text-gray-500 mb-6">{description}</p>
          <div className="flex gap-4 w-full">
            <button
              className="px-6 py-3 rounded-lg border border-gray-200 bg-white text-gray-700 font-semibold shadow w-full"
              onClick={onClose}
            >
              {cancelLabel}
            </button>
            <button
              className="px-6 py-3 rounded-lg bg-blue-600 text-white font-semibold shadow bg-[#0033CC] w-full"
              onClick={onConfirm}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
